import {useState, useEffect, useRef, Fragment, memo, useContext} from "react"
import {SocketContext} from '@src/utility/context/Socket'
import {Link} from "react-router-dom"
import Avatar from "@components/avatar"
import {useDispatch, useSelector} from "react-redux"
import {
    storeMessagesInRedux,
    addBrandContactsInRedux,
    sendMsgRD,
    uploadMediaToserver,
    recieveMsg,
    sendBroadcastMsg,
    myRdList,
    allRdList,
    archiveConversation,
    unarchiveConversation,
    markConversationUnread
} from "./store/actions"
import {
    getFavoriteFolders,
    getFavoriteRDProfiles,
    getCountries,
    getAllStates
} from '@src/redux/actions/brandsDashboard'
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import CustomAvatar from '@src/views/components/CustomAvatar'
import {
    MessageSquare,
    Paperclip,
    FileText,
    Heart,
    ArrowLeftCircle,
    File,
    ChevronLeft,
    Send,
    Image,
    X,
    MessageCircle,
    Info,
    Users,
    User,
    MoreVertical,
    Mail,
    Clock,
    Plus
} from "react-feather"
import {
    Form,
    Input,
    Label,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    FormGroup,
    CustomInput,
    Card,
    CardBody,
    Row,
    Col,
    Spinner,
    UncontrolledButtonDropdown,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Alert
} from "reactstrap"
import { ArchiveIcon, UnarchiveIcon } from '@src/views/components/ArchiveIcons'
import {allowedFiles, allowedFilesErrorMessages} from '@src/utility/Utils'
import BlankProfile from "@src/assets/images/avatars/avatar-blank.png"
import {Slide, toast} from "react-toastify"
import {getGoalsAttributes} from '@src/views/brands/nutritionExperts/store/actions'
import {
    rdGroupList,
    rdGroupListReset
} from "@src/redux/actions/BrandActions"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import draftToHtml from "draftjs-to-html"
import {ContentState, convertToRaw, EditorState} from "draft-js"
import {Editor} from "react-draft-wysiwyg"
import '@styles/react/libs/editor/editor.scss'
import '@styles/base/plugins/forms/form-quill-editor.scss'
import htmlToDraft from "html-to-draftjs"
import {PropTypes} from "prop-types"
import MsgTemplates from '@src/views/components/MsgTemplates'
import useMessageFollowUp, { formatMonthYear } from '@src/views/components/hooks/useMessageFollowUp'
import { HiChatBubbleLeftRight } from 'react-icons/hi2'
import BrandSampleSurveyCard from './BrandSampleSurveyCard'
import MassMessageModal from './MassMessageModal'

const ChatLog = (props) => {
    const sweetAlert = withReactContent(Swal)

    const ps = useRef([])
    const {
        handleUser,
        handleUserSidebarRight,
        handleSidebar,
        store,
        userSidebarLeft,
        user,
        selectedUserID,
        selectedUserBrandChat,
        selectedContactDetail,
        currentUser,
        onTabChange,
        activeTab
    } = props

    const brandChatStoreSlice = useSelector((state) => state.chatBrands)

    const brandsDashboardStoreSlice = useSelector(store => store.brandsDashboardSlice)

    const {
        rdGroupListLoading,
        rdGroupListData,
        rdGroupListError
    } = useSelector(state => state.brandReducer)

    const chatArea = useRef(null)
    const dispatch = useDispatch()
    const socket = useContext(SocketContext)

    const chatMessages = selectedUserBrandChat?.data || []
    const currentUserId = currentUser?.chat_id || currentUser?.id
    const otherUserChatId = selectedContactDetail?.chat_user
    const {showFollowUp, daysSince, isLongWait, lastMessageDate, monthYear} = useMessageFollowUp(chatMessages, currentUserId, otherUserChatId)

    const isThreadArchived = Boolean(
        selectedContactDetail?.is_archived === true ||
        selectedContactDetail?.is_archived === 1 ||
        selectedContactDetail?.is_archived === '1' ||
        selectedContactDetail?.is_archived === 'true' ||
        (store?.archiveContacts?.data || []).some(item => {
            const id = item?.chat_user || item?.user_id
            return id != null && otherUserChatId != null && String(id) === String(otherUserChatId)
        })
    )

    // Helper: format WhatsApp-style timestamp — always 12-hour AM/PM
    const formatMsgTime = (timezone) => {
        if (!timezone) return ''
        const d = new Date(timezone)
        if (isNaN(d.getTime())) return timezone

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        const msgDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())
        const timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })

        if (msgDate.getTime() === today.getTime()) {
            return `Today, ${timeStr}`
        } else if (msgDate.getTime() === yesterday.getTime()) {
            return `Yesterday, ${timeStr}`
        } else {
            const dateStr = d.toLocaleDateString([], { month: 'short', day: 'numeric' })
            return `${dateStr}, ${timeStr}`
        }
    }

    // Helper: format month + year for long-wait banner
    const formatMonthYear = (date) => {
        if (!date) return ''
        return date.toLocaleDateString([], {month: 'long', year: 'numeric'})
    }

    // Helper: format header subtitle status
    const getHeaderSubtitle = () => {
        if (!selectedContactDetail) return null
        if (selectedContactDetail.is_mass_group || selectedContactDetail.user_type === 'mass') {
            return <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>Broadcast log</small>
        }
        if (selectedContactDetail?.status === 0 || selectedContactDetail?.status === '0' || selectedContactDetail?.is_active === 0 || selectedContactDetail?.is_active === '0') {
            return <small className='text-danger text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>Account is blocked</small>
        }
        const lastMsg = (chatMessages && chatMessages.length > 0) ? chatMessages[chatMessages.length - 1] : null
        const rawDate = lastMsg?.created_at || lastMsg?.timezone || selectedContactDetail?.last_message_created_at || selectedContactDetail?.created_at || selectedContactDetail?.last_message_timezone || selectedContactDetail?.timezone || selectedContactDetail?.last_message_time
        if (!rawDate) {
            return <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>No messages yet</small>
        }
        const dateObj = new Date(rawDate)
        const isValidDate = !isNaN(dateObj.getTime())
        if (!isValidDate) {
            return null
        }

        const timeStr = dateObj.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })
        const dateStr = dateObj.toLocaleDateString([], { day: 'numeric', month: 'short' })
        const subtitleText = `Last message · ${dateStr}, ${timeStr}`

        return (
            <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>
                {subtitleText}
            </small>
        )
    }

    // ** State
    const [msg, setMsg] = useState("")
    const [questate, setQueState] = useState({inQueFilePreview: "", inQueFile: ""})
    const [selectedFile, setSelectedFile] = useState(null)
    const [isFilePicked, setIsFilePicked] = useState(false)
    const [isOpenTempleteModal, setIsOpenTempleteModal] = useState(false)
    const [isOpenBroadcastModal, setIsOpenBroadcastModal] = useState(false)
    const [broadcastMessage, setBroadcastMessage] = useState('')
    const [selectedBroadcastContacts, setSelectedBraodcastContacts] = useState([])
    const [broadCastRDsList, setBroadCastRDsList] = useState([])
    const [broadCastRDsListLoading, setBroadCastRDsListLoading] = useState(false)
    const [fileUploadError, setFileUploadError] = useState(false)
    const [checkAllVal, setCheckAllVal] = useState(false)
    const [showFav, setShowFav] = useState(false)
    const [favFolderList, setFavFolderList] = useState(null)
    const [favFolderId, setFavFolderId] = useState(null)
    const [favFolderTitle, setFavFolderTitle] = useState(null)
    const [backToFav, setBackToFav] = useState(false)
    const [showPreviewModal, setShowPreviewModal] = useState(false)
    const [selectedRds, setSelectedRds] = useState([])
    const [selectedRadio, setSelectedRadio] = useState('')
    const [broadCastSendLoader, setBroadCastSendLoader] = useState(false)
    const [broadCastResMsg, setBroadCastResMsg] = useState(null)
    const [isMessageExpanded, setIsMessageExpanded] = useState(false)
    const [broadCastResStatus, setBroadCastResStatus] = useState(null)
    const [sendMsgLoader, setSendMsgLoader] = useState(false)
    const [showGroups, setShowGroups] = useState(false)
    const [groupData, setGroupData] = useState({speciality: [], industry: [], characteristics: []})
    const [selectedGroupLabels, setSelectedGroupLabels] = useState([])
    const [massMsgEditorState, setMassMsgEditorState] = useState(null)
    const [msgEditorState, setMsgEditorState] = useState(null)
    const [templateType, setTemplateType] = useState(null)
    const [openTemplatesModal, setOpenTemplatesModal] = useState(false)
    const [recipientSearch, setRecipientSearch] = useState('')
    const [recipientLimit, setRecipientLimit] = useState(60)
    const [showTemplateBar, setShowTemplateBar] = useState(false)
    const templateBarRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (templateBarRef.current && !templateBarRef.current.contains(event.target)) {
                setShowTemplateBar(false)
            }
        }
        if (showTemplateBar) {
            document.addEventListener('mousedown', handleClickOutside)
            document.addEventListener('touchstart', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('touchstart', handleClickOutside)
        }
    }, [showTemplateBar])

    const scrollToBottom = () => {
        if (chatArea.current) {
            chatArea.current.scrollTop = chatArea.current.scrollHeight
        }
    }

    useEffect(() => {
        socket.on("connect", (error) => {
            if (error) {
                alert(error)
            }
        })

        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        socket.emit("join", user, (error) => {
        })

        if (selectedUserID) {
            const selectedChatRdContactRaw = localStorage.getItem('selectedChatRd')
            const selectedChatRdContact = selectedChatRdContactRaw ? JSON.parse(selectedChatRdContactRaw) : {}
            dispatch(addBrandContactsInRedux({chat_user: parseInt(selectedUserID), ...selectedChatRdContact}))
        }

        dispatch(getGoalsAttributes())
        dispatch(getCountries())
        dispatch(getAllStates())
    }, [])

    useEffect(() => {
        if (selectedContactDetail) {
            scrollToBottom()
            setRecipientLimit(60)
            setRecipientSearch('')
            setIsMessageExpanded(false)
        }

        if (!!brandChatStoreSlice?.braodcastContactList) {
            setBroadCastRDsListLoading(false)
            setBroadCastRDsList(brandChatStoreSlice.braodcastContactList.data)
        }

        if (!!brandChatStoreSlice?.broadcastResponse) {
            if (brandChatStoreSlice?.broadcastResponse?.status === true) {
                setBroadCastResMsg(brandChatStoreSlice?.broadcastResponse?.msg)
                setBroadCastResStatus(brandChatStoreSlice?.broadcastResponse?.status)
                setBroadCastSendLoader(false)
                setIsOpenBroadcastModal(false)
                setSelectedBraodcastContacts([])
                setCheckAllVal(false)
                setBroadCastRDsList([])
                dispatch({type: 'CLEAT_BROADCAST_LIST'})
                dispatch({type: 'CLEAT_BROADCAST_SUCCESS_RESPONSE'})
                dispatch({type: 'CLEAR_CHAT_CONTENT_ON_LOAD'})
                dispatch({type: 'CLEAR_CHAT_CONTACT_ON_LOAD'})
                setTimeout(() => {
                    setShowPreviewModal(false)
                    setBroadCastResMsg(null)
                    setBroadCastResStatus(null)
                    setSelectedRds([])
                    setBroadcastMessage("")
                    setMassMsgEditorState(null)
                }, 5000)
            }

            if (brandChatStoreSlice?.broadcastResponse?.config) {
                sweetAlert.fire({
                    title: 'Error!',
                    icon: 'error',
                    html: `<p>Status: ${brandChatStoreSlice?.broadcastResponse?.response?.status || 500}</p><p>${JSON.stringify(brandChatStoreSlice?.broadcastResponse?.response?.data ?? "Internal Server Error")}</p>`,
                    allowOutsideClick: false,
                    showCancelButton: false
                })
                setBroadCastSendLoader(false)
                dispatch({type: 'CLEAT_BROADCAST_SUCCESS_RESPONSE'})
            }
        }

        if (brandChatStoreSlice?.sendMessageResponse) {
            setSendMsgLoader(false)
            if (brandChatStoreSlice?.sendMessageResponse.status) {
                toast.success(
                    <Fragment>
                        <div className='toastify-header'>
                            <div className='title-wrapper'>
                                <Avatar size='sm' color='success' icon={<MessageSquare size={12}/>}/>
                                <h6 className='toast-title font-weight-bold'>Success</h6>
                            </div>
                        </div>
                        <div className='toastify-body'>
                            <span>{brandChatStoreSlice?.sendMessageResponse?.msg}</span>
                        </div>
                    </Fragment>, {transition: Slide, hideProgressBar: true, autoClose: 5000})
            } else {
                toast.error(<Fragment>{brandChatStoreSlice?.sendMessageResponse?.msg}</Fragment>, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 5000
                })
            }
            setMsg("")
            setMsgEditorState(null)
            dispatch({type: "SEND_MSG_NULL_RESPONSE"})
        }

        const error = brandChatStoreSlice?.chatLoadError?.response?.status
        if (error && error !== 401) {
            dispatch({type: "BRAND_CHAT_LOAD_ERROR_RESET"})
            dispatch({type: "SELECTED_CHAT_LOADER_RESET"})
            sweetAlert.fire({
                title: 'Connection Error!',
                icon: 'error',
                html: '<p>Please reload the page.</p>',
                confirmButtonText: 'Reload',
                allowOutsideClick: false,
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })
        }
    }, [brandChatStoreSlice])

    useEffect(() => {
        socket.on('new-user-message', (data) => {
            const receivedMessage = {
                message: data.data.message,
                media: data.data.media,
                from_user_id: data.data.from_user_id,
                to_user_id: data.data.to_user_id
            }
            // console.log('new-user-message data', data)
            // console.log('new-user-message', receivedMessage)
            dispatch(recieveMsg(receivedMessage))
        })
    }, [])

    useEffect(() => {
        if (brandsDashboardStoreSlice?.favoriteFoldersRes) {
            setBroadCastRDsListLoading(false)
            setFavFolderList(brandsDashboardStoreSlice?.favoriteFoldersRes?.data)
        }

        if (brandsDashboardStoreSlice?.favoriteRDProfilesRes) {
            setBroadCastRDsListLoading(false)
            const data = brandsDashboardStoreSlice?.favoriteRDProfilesRes?.data.map((item) => {
                return {
                    user_id: item.id,
                    profile_img: item.profile_img,
                    name: item.name,
                    is_favorite: null,
                    folder_title: null
                }
            })
            setBroadCastRDsList(data)
        }
    }, [brandsDashboardStoreSlice])

    useEffect(() => {
        if (rdGroupListData?.data) {
            setBroadCastRDsList(rdGroupListData?.data)
            setSelectedBraodcastContacts(rdGroupListData?.data.map(item => item?.user_id))
            setSelectedRds(rdGroupListData?.data.map(item => item?.name))
        }
    }, [rdGroupListData])

    const getBase64 = (img, callback) => {
        if (img) {
            const reader = new FileReader()
            reader.addEventListener('load', () => callback(reader.result))
            reader.readAsDataURL(img)
        }
    }

    const handleSendMsg = (e) => {
        e.preventDefault()
        setSendMsgLoader(true)
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedContactDetail.chat_user
        const date = new Date()
        const objTest = {
            chat: [],
            selectedRd: selectedUserID
        }
        const msgObj = {
            message: msg,
            from_user_id: user.chat_id,
            to_user_id: receiver_id,
            timezone: date.toString()
        }
        objTest.chat.push(msgObj)
        dispatch(storeMessagesInRedux(objTest))
        dispatch(sendMsgRD(msgObj))
        socket.emit("new-message", msgObj)
        if (selectedFile) {
            const media = {
                to_user_id: receiver_id,
                file: selectedFile,
                from_user_id: user.chat_id,
                socket
            }
            dispatch(uploadMediaToserver(media))
            setIsFilePicked(false)
            setSelectedFile('')
            setQueState(prevState => ({
                ...prevState,
                inQueFilePreview: '',
                inQueFile: ''
            }))
        }
    }

    const changeHandler = (event) => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedContactDetail.chat_user
        const file = event.target.files[0]
        setFileUploadError(false)
        if (!file) return
        if (allowedFiles().includes(file.name?.split('.').pop().toLowerCase())) {
            setSelectedFile(file)

            getBase64(file, imageUrl => {
                // console.log('inQueFilePreview', imageUrl)
                setQueState(prevState => ({
                    ...prevState,
                    inQueFilePreview: imageUrl,
                    inQueFile: file
                }))
            })
            setIsFilePicked(true)
        } else {
            setSelectedFile(null)
            setQueState({
                inQueFilePreview: '',
                inQueFile: ''
            })
            setFileUploadError(true)
        }
    }

    const appendTemplate = (item) => {
        const content = htmlToDraft(item.template)
        const contentState = ContentState.createFromBlockArray(content?.contentBlocks)
        const createContent = EditorState.createWithContent(contentState)
        if (item?.type === 'message') {
            setMsgEditorState(createContent)
            setMsg(item.template)
        } else {
            setMassMsgEditorState(createContent)
            setBroadcastMessage(item.template)
        }
    }

    const getRdList = (option) => {
        setSelectedBraodcastContacts([])
        setBroadCastRDsList([])
        setCheckAllVal(false)
        setFavFolderList(null)
        setBackToFav(false)
        setSelectedRds([])
        setSelectedGroupLabels([])
        dispatch({type: "CLEAR_FAV_FOLDERS_LIST"})
        dispatch({type: "CLEAR_FAV_PROFILES"})
        setSelectedRadio(option)
        if (option === 'my_rds') {
            setBroadCastRDsListLoading(true)
            setShowFav(false)
            setShowGroups(false)
            dispatch(myRdList())
        } else if (option === 'all_rds') {
            setBroadCastRDsListLoading(true)
            setShowFav(false)
            setShowGroups(false)
            dispatch(allRdList())
        } else if (option === 'groups') {
            setBroadCastRDsListLoading(false)
            setShowFav(false)
            setShowGroups(true)
        } else if (option === 'favourites') {
            setBroadCastRDsListLoading(true)
            setShowFav(true)
            setShowGroups(false)
            const API_URL = process.env.REACT_APP_BASEURL
            dispatch(getFavoriteFolders(true, `${API_URL}brand/load-folder-list?list=all`))
        }
    }

    const handleSelectBroadCastingContact = (contact) => {
        setCheckAllVal(false)
        let list = [...selectedBroadcastContacts]
        let names = [...selectedRds]
        if (!list.includes(contact.user_id)) {
            list.push(contact.user_id)
            names.push(contact.name)
        } else {
            list = list.filter(id => id !== contact.user_id)
            names = names.filter(name => name !== contact.name)
        }
        setSelectedBraodcastContacts(list)
        setSelectedRds(names)
    }

    const computeMassMessageTitle = () => {
        const count = selectedBroadcastContacts.length
        if (selectedRadio === 'my_rds') {
            if (checkAllVal || (broadCastRDsList.length > 0 && count === broadCastRDsList.length)) {
                return 'Mass Message to My RDs'
            }
            return `Mass Message to ${count} Selected RD${count === 1 ? '' : 's'}`
        }
        if (selectedRadio === 'all_rds') {
            if (checkAllVal || (broadCastRDsList.length > 0 && count === broadCastRDsList.length)) {
                return 'Mass Message to All RDs'
            }
            return `Mass Message to ${count} Selected RD${count === 1 ? '' : 's'}`
        }
        if (selectedRadio === 'favourites' && favFolderTitle) {
            const cleanFolder = favFolderTitle.trim()
            if (cleanFolder.toLowerCase().endsWith('rds') || cleanFolder.toLowerCase().endsWith('rd')) {
                return `Mass Message to ${cleanFolder}`
            }
            return `Mass Message to ${cleanFolder} RDs`
        }
        if (selectedRadio === 'groups' && selectedGroupLabels && selectedGroupLabels.length > 0) {
            if (selectedGroupLabels.length === 1) {
                return `Mass Message to ${selectedGroupLabels[0]} RDs`
            }
            if (selectedGroupLabels.length === 2) {
                return `Mass Message to ${selectedGroupLabels[0]} and ${selectedGroupLabels[1]} RDs`
            }
            if (selectedGroupLabels.length === 3) {
                return `Mass Message to ${selectedGroupLabels[0]}, ${selectedGroupLabels[1]} and ${selectedGroupLabels[2]} RDs`
            }
            return `Mass Message to ${count} Filtered RDs`
        }
        return `Mass Message to ${count} Selected RD${count === 1 ? '' : 's'}`
    }

    const sendBroadcastMessage = () => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const date = new Date()
        const targetTitle = computeMassMessageTitle()
        const msgObj = {
            message: broadcastMessage,
            from_user_id: user.chat_id,
            role: "rd",
            socket,
            to_users: selectedBroadcastContacts,
            target_title: targetTitle,
            mass_title: targetTitle,
            timezone: date.toString()
        }
        setBroadCastSendLoader(true)
        dispatch(sendBroadcastMsg(msgObj))
    }

    const handleFollowUpClick = () => {
        const defaultFollowUp = '<p>Hi! Just following up on my previous message to see if you had any questions.</p>'
        const content = htmlToDraft(defaultFollowUp)
        const contentState = ContentState.createFromBlockArray(content?.contentBlocks)
        setMsgEditorState(EditorState.createWithContent(contentState))
        setMsg(defaultFollowUp)
    }

    // Helper: extract date string key for date divider grouping
    const getDateKey = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return ''
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    }

    // Helper: format center date divider banner (e.g. Jun 17, 2026 / Today / Yesterday)
    const formatDateDivider = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return rawTime

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        const msgDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())

        if (msgDate.getTime() === today.getTime()) {
            return 'Today'
        }
        if (msgDate.getTime() === yesterday.getTime()) {
            return 'Yesterday'
        }
        return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
    }

    // Helper: format time only (e.g. 9:14 AM or 11:32 AM)
    const formatTimeOnly = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return ''
        return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    }

    const renderChats = () => {
        const messages = selectedUserBrandChat?.data
        if (!messages || messages.length === 0) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center" style={{height: '100%', minHeight: '200px', color: '#aaa'}}>
                    <MessageSquare size={40} style={{marginBottom: '10px', opacity: 0.4}}/>
                    <p style={{fontSize: '0.9rem'}}>No messages yet. Start the conversation!</p>
                </div>
            )
        }

        const latestSurveyMsgIdMap = {}
        messages.forEach(msg => {
            if (msg.message_type === 'sample_survey') {
                const key = msg.participate_request_id || 'default'
                latestSurveyMsgIdMap[key] = msg.msg_id || msg.id
            }
        })

        // Filter out older duplicate sample_survey messages completely
        const filteredMessages = messages.filter(msg => {
            if (msg.message_type === 'sample_survey') {
                const key = msg.participate_request_id || 'default'
                return latestSurveyMsgIdMap[key] === (msg.msg_id || msg.id)
            }
            return true
        })

        return filteredMessages.map((item, index) => {
            const otherId = parseInt(selectedContactDetail?.chat_user)
            const isSentByMe = parseInt(item?.to_user_id) === otherId || (parseInt(item?.from_user_id) !== otherId && !isNaN(parseInt(item?.from_user_id)))
            const senderName = isSentByMe ? 'You' : (selectedContactDetail?.name || selectedContactDetail?.rd_name || 'Them')
            const timeOnly = formatTimeOnly(item.timezone || item.created_at)
            const timeLabel = `${senderName} · ${timeOnly}`
            const isLatestSurveyMsg = item.message_type === 'sample_survey' && latestSurveyMsgIdMap[item.participate_request_id || 'default'] === (item.msg_id || item.id)

            const currentDateKey = getDateKey(item.timezone || item.created_at)
            const prevDateKey = index > 0 ? getDateKey(messages[index - 1].timezone || messages[index - 1].created_at) : null
            const showDateDivider = currentDateKey && currentDateKey !== prevDateKey

            return (
                <Fragment key={index}>
                    {showDateDivider && (
                        <div className='chat-date-divider text-center my-1 w-100'>
                            <span>
                                {formatDateDivider(item.timezone || item.created_at)}
                            </span>
                        </div>
                    )}
                    <div
                        ref={(el) => (ps.current[index] = el)}
                        className={classnames("chat", {
                            "chat-left": !isSentByMe
                        })}
                    >
                        <div className="chat-body">
                            {/* Sender Name + Time ABOVE Bubble */}
                            <div className={classnames('chat-meta-top mb-25', {
                                'text-right': isSentByMe,
                                'text-left': !isSentByMe
                            })}>
                                <span>
                                    {timeLabel}
                                </span>
                            </div>

                            {/* Message Content */}
                            {item.media ? (
                                <div className="chat-content media-file">
                                    {item.message_type === "img" && (
                                        <div>
                                            <img src={item.media} height="200" title={item.file_name} alt={item.file_name}/>
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                               style={{textDecoration: "underline"}}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                    {item.message_type === "pdf" && (
                                        <div>
                                            <File size={100} style={{color: '#56B6FF'}}/>
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                               style={{textDecoration: "underline"}}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                    {item.message_type === "doc" && (
                                        <div>
                                            <File size={100} style={{color: '#56B6FF'}}/>
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                               style={{textDecoration: "underline"}}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ) : item.message_type === "sample_survey" ? (
                                <BrandSampleSurveyCard message={item} participateRequestId={item.participate_request_id} />
                            ) : (
                                <div className="chat-content">
                                    <div dangerouslySetInnerHTML={{__html: item.message}}></div>
                                </div>
                            )}
                        </div>
                    </div>
                </Fragment>
            )
        })
    }

    const renderMassMessageContent = () => {
        const detail = brandChatStoreSlice?.massMessageDetail
        const selectedUserBrandChatLoading = brandChatStoreSlice?.selectedUserBrandChatLoading
        if (selectedUserBrandChatLoading) {
            return (
                <div className="d-flex align-items-center justify-content-center p-5">
                    <Spinner color="primary" /> <span className="ml-2">Loading broadcast detail...</span>
                </div>
            )
        }
        const messageHtml = detail?.message || selectedContactDetail?.last_message || ''
        const recipients = (detail?.recipients || []).slice().sort((a, b) => {
            const nameA = (a?.name || a?.rd_name || '').trim().toLowerCase()
            const nameB = (b?.name || b?.rd_name || '').trim().toLowerCase()
            return nameA.localeCompare(nameB)
        })
        const filteredRecipients = recipients.filter(r => (r?.name || r?.rd_name || '').toLowerCase().includes(recipientSearch.toLowerCase()))
        const rawTitle = (detail?.name || detail?.title || selectedContactDetail?.name || '').trim()
        const isSelectedManual = rawTitle.toLowerCase().includes('selected')
        const categoryName = rawTitle.replace(/^Mass Message to\s+/i, '').trim() || 'All RDs'
        const totalCount = detail?.total_recipients || recipients.length || 0

        return (
            <div className="mass-broadcast-page">
                {/* 1. Broadcast Header / Hero Card */}
                <div className="mass-broadcast-hero mb-1">
                    <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: '12px' }}>
                        <div className="d-flex align-items-center">
                            <div className="mass-hero-icon mr-1 flex-shrink-0">
                                <HiChatBubbleLeftRight size={22} />
                            </div>
                            <div>
                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#1e293b', fontSize: '15px' }}>
                                        {rawTitle || 'Mass Message Broadcast'}
                                    </h5>
                                    <Badge color="light-success" pill style={{ fontSize: '11px', padding: '3px 8px' }}>
                                        Broadcast Sent
                                    </Badge>
                                </div>
                                <div className="d-flex align-items-center text-muted mt-25 flex-wrap" style={{ fontSize: '12px', gap: '14px' }}>
                                    <span className="d-inline-flex align-items-center">
                                        <Clock size={13} className="mr-50 text-muted" />
                                        {detail?.created_at || selectedContactDetail?.created_at || 'Sent recently'}
                                    </span>
                                    <span className="d-inline-flex align-items-center">
                                        <Users size={13} className="mr-50 text-muted" />
                                        {totalCount} Total Recipient{totalCount === 1 ? '' : 's'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Quick action button to compose new mass message */}
                        <Button
                            color="primary"
                            size="sm"
                            className="d-inline-flex align-items-center"
                            style={{
                                height: '34px',
                                borderRadius: '8px',
                                padding: '0 14px',
                                fontSize: '12px',
                                fontWeight: 500
                            }}
                            onClick={() => {
                                setIsOpenBroadcastModal(true)
                                setSelectedBraodcastContacts([])
                                setCheckAllVal(false)
                                setSelectedRds([])
                                getRdList('my_rds')
                            }}
                        >
                            <Send size={13} className="mr-50" />
                            <span>New Broadcast</span>
                        </Button>
                    </div>
                </div>

                {/* 2. Broadcast Message Content Bubble */}
                <div className="mass-message-card mb-1">
                    <div className="d-flex align-items-center justify-content-between mb-1 pb-50 border-bottom">
                        <div className="d-flex align-items-center">
                            <Bookmark size={15} className="text-primary mr-50" />
                            <h6 className="mb-0 font-weight-bold" style={{ fontSize: '13.5px', color: '#1e293b' }}>
                                Broadcast Message Content
                            </h6>
                        </div>
                        <span className="text-muted small" style={{ fontSize: '11.5px' }}>
                            Delivered to {totalCount} RD{totalCount === 1 ? '' : 's'}
                        </span>
                    </div>

                    <div
                        className="mass-message-body p-1 rounded"
                        style={{
                            background: '#f8fafc',
                            maxHeight: isMessageExpanded ? 'none' : '90px',
                            overflow: 'hidden',
                            wordBreak: 'break-word',
                            transition: 'max-height 0.25s ease-in-out',
                            border: '1px solid #e2e8f0'
                        }}
                        dangerouslySetInnerHTML={{ __html: messageHtml }}
                    />

                    {messageHtml && messageHtml.replace(/<[^>]*>?/gm, '').length > 130 && (
                        <div className="text-right mt-50">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-primary font-weight-bold"
                                style={{ fontSize: '12px', textDecoration: 'none' }}
                                onClick={() => setIsMessageExpanded(!isMessageExpanded)}
                            >
                                {isMessageExpanded ? 'Show less ▲' : 'Read full message ▼'}
                            </button>
                        </div>
                    )}
                </div>

                {/* 3. Recipients / Audience Section */}
                {isSelectedManual ? (
                    <div className="mass-recipients-card mb-1">
                        <div className="d-flex align-items-center justify-content-between mb-1 pb-50 border-bottom flex-wrap" style={{ gap: '10px' }}>
                            <div className="d-flex align-items-center">
                                <Users size={16} className="text-primary mr-50" />
                                <h6 className="mb-0 font-weight-bold" style={{ fontSize: '13.5px', color: '#1e293b' }}>
                                    Recipients Directory ({totalCount} Dietitians)
                                </h6>
                            </div>

                            {recipients.length > 6 && (
                                <div style={{ width: '220px' }}>
                                    <Input
                                        type="text"
                                        placeholder="Search recipients by name..."
                                        bsSize="sm"
                                        value={recipientSearch}
                                        onChange={e => {
                                            setRecipientSearch(e.target.value)
                                            setRecipientLimit(60)
                                        }}
                                        style={{ borderRadius: '6px', fontSize: '11.5px', height: '30px' }}
                                    />
                                </div>
                            )}
                        </div>

                        <div
                            className="mass-recipients-scroll-box"
                            onWheel={(e) => {
                                e.stopPropagation()
                                if (e.currentTarget) {
                                    e.currentTarget.scrollTop += e.deltaY
                                }
                            }}
                            onScroll={(e) => {
                                const { scrollTop, scrollHeight, clientHeight } = e.currentTarget
                                if (scrollHeight - scrollTop - clientHeight < 150) {
                                    if (recipientLimit < filteredRecipients.length) {
                                        setRecipientLimit(prev => Math.min(prev + 60, filteredRecipients.length))
                                    }
                                }
                            }}
                            style={{
                                maxHeight: '250px',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                paddingRight: '6px'
                            }}
                        >
                            <Row>
                                {filteredRecipients.slice(0, recipientLimit).map((r, i) => (
                                    <Col key={i} xs={12} sm={6} md={4} className="mb-1">
                                        <Link
                                            to={`/dashboard/brands/nutritions/${r.user_id}`}
                                            className="mass-recipient-chip h-100"
                                            title="View RD profile"
                                        >
                                            <CustomAvatar
                                                name={r.name}
                                                img={r.profile_image}
                                                imgHeight="32"
                                                imgWidth="32"
                                                className="mr-75 flex-shrink-0 avatar-img-fit-contain"
                                            />
                                            <div className="text-truncate flex-grow-1 min-w-0">
                                                <span className="text-dark font-weight-bold d-block text-truncate" style={{ fontSize: '12px' }}>
                                                    {r.name}
                                                </span>
                                                <small className="text-muted d-block text-truncate" style={{ fontSize: '10.5px' }}>
                                                    View Profile →
                                                </small>
                                            </div>
                                        </Link>
                                    </Col>
                                ))}

                                {filteredRecipients.length === 0 && (
                                    <Col xs={12} className="text-center py-3 text-muted" style={{ fontSize: '12px' }}>
                                        No matching recipients found.
                                    </Col>
                                )}

                                {recipientLimit < filteredRecipients.length && (
                                    <Col xs={12} className="text-center py-1">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            style={{ fontSize: '11px', borderRadius: '6px', padding: '4px 14px' }}
                                            onClick={() => setRecipientLimit(prev => Math.min(prev + 90, filteredRecipients.length))}
                                        >
                                            Load more ({Math.min(recipientLimit, filteredRecipients.length)} of {filteredRecipients.length})
                                        </button>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    </div>
                ) : (
                    <div className="mass-recipients-card mb-1">
                        <div className="d-flex align-items-center justify-content-between mb-1 pb-50 border-bottom">
                            <div className="d-flex align-items-center">
                                <Users size={16} className="text-primary mr-50" />
                                <h6 className="mb-0 font-weight-bold" style={{ fontSize: '13.5px', color: '#1e293b' }}>
                                    Target Audience Category
                                </h6>
                            </div>
                            <Badge color="light-primary" pill style={{ fontSize: '11px', padding: '4px 10px' }}>
                                {totalCount} Total Dietitians
                            </Badge>
                        </div>

                        <div className="d-flex align-items-center p-1 rounded border" style={{ background: '#f8fafc', gap: '12px' }}>
                            <div
                                className="d-flex align-items-center justify-content-center flex-shrink-0"
                                style={{
                                    width: '38px',
                                    height: '38px',
                                    borderRadius: '10px',
                                    backgroundColor: 'rgba(86, 182, 255, 0.12)',
                                    color: '#008be3',
                                    border: '1.5px solid rgba(86, 182, 255, 0.35)'
                                }}
                            >
                                <Users size={19} />
                            </div>
                            <div>
                                <span className="text-muted small d-block" style={{ fontSize: '11.5px' }}>Target Segment:</span>
                                <h6 className="mb-0 font-weight-bold text-dark" style={{ fontSize: '14px' }}>
                                    {categoryName}
                                </h6>
                            </div>
                        </div>
                    </div>
                )}

                {/* 4. 1:1 Reply Branching Information Card */}
                <Alert color="info" className="d-flex align-items-center py-1 px-1 mb-0" style={{ fontSize: '12px', borderRadius: '10px' }}>
                    <Info size={18} className="mr-1 flex-shrink-0 text-info" />
                    <div>
                        <strong>1:1 Reply Branching Active:</strong> This broadcast was sent to multiple dietitians simultaneously. Any response a dietitian sends will automatically open as a separate, private 1:1 conversation directly in your Inbox.
                    </div>
                </Alert>
            </div>
        )
    }

    const handleStartConversation = () => {
        if (!userSidebarLeft && window.innerWidth <= 1200) {
            handleSidebar()
        }
    }

    const isMassGroupSelected = selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass'
    const ChatWrapper = (selectedContactDetail && selectedUserBrandChat && !isMassGroupSelected) ? PerfectScrollbar : 'div'

    const handleCheckAll = (e) => {
        const checked = e.target.checked
        const list = [...selectedBroadcastContacts]
        const names = [...selectedRds]
        if (checked) {
            setCheckAllVal(true)
            for (const item of broadCastRDsList) {
                if (!list.includes(item.user_id)) {
                    list.push(item.user_id)
                    names.push(item.name)
                }
            }
            setSelectedBraodcastContacts(list)
            setSelectedRds(names)
        } else {
            setCheckAllVal(false)
            setSelectedBraodcastContacts([])
            setSelectedRds([])
        }
    }

    const handleSelectedFolder = (folderId, folderTitle) => {
        setBackToFav(true)
        setShowFav(false)
        setFavFolderId(folderId)
        setFavFolderTitle(folderTitle)
        setBroadCastRDsListLoading(true)
        setSelectedBraodcastContacts([])
        setBroadCastRDsList([])
        setFavFolderList(null)
        dispatch({type: "CLEAR_FAV_FOLDERS_LIST"})
        const API_URL = process.env.REACT_APP_BASEURL
        dispatch(getFavoriteRDProfiles(true, `${API_URL}brand/favorites-profiles?folder_id=${folderId}&list=all`, ''))
    }

    const handleGroupChange = (category, event, value) => {
        dispatch(rdGroupListReset())
        setBroadCastRDsList([])
        setSelectedBraodcastContacts([])
        const label = value?.label || ''
        if (label) {
            setSelectedGroupLabels(prev => {
                if (event.target.checked) {
                    return [...prev.filter(l => l !== label), label]
                } else {
                    return prev.filter(l => l !== label)
                }
            })
        }
        setGroupData(prevGroupData => {
            const newGroupData = {...prevGroupData}
            const index = newGroupData[category].indexOf(value?.id)
            if (index === -1) {
                newGroupData[category] = [...newGroupData[category], value?.id]
            } else {
                newGroupData[category] = [
                    ...newGroupData[category].slice(0, index),
                    ...newGroupData[category].slice(index + 1)
                ]
            }
            return newGroupData
        })
    }

    useEffect(() => {
        if (groupData.speciality.length > 0 || groupData.industry.length > 0 || groupData.characteristics.length > 0) {
            dispatch(rdGroupList({
                speciality: groupData.speciality,
                industry: groupData.industry,
                personal_attr: groupData.characteristics,
                filter: 'list'
            }))
        }
    }, [groupData])

    const { setMassMessageTrigger } = props

    useEffect(() => {
        if (setMassMessageTrigger) {
            setMassMessageTrigger(() => {
                setIsOpenBroadcastModal(true)
                setSelectedBraodcastContacts([])
                setCheckAllVal(false)
                setSelectedRds([])
                getRdList('my_rds')
            })
        }
    }, [setMassMessageTrigger])

    return (
        <Fragment>
            <div className="chat-app-window w-100 chat-brand">
                <div className={classnames("start-chatArea-parent", {
                    "d-none": !!selectedContactDetail
                })}>
                    <div className="chat-navbar">
                        <header className="chat-header d-flex align-items-center justify-content-end px-1">
                            <div className="ml-auto d-flex align-items-center">
                                <Button.Ripple
                                    color='primary'
                                    id="send-mass-msg-empty-state"
                                    title="Send a mass message"
                                    size='sm'
                                    className='d-inline-flex align-items-center ml-auto'
                                    style={{ height: '34px', borderRadius: '8px', padding: '0 12px', fontSize: '12px' }}
                                    onClick={() => {
                                        setIsOpenBroadcastModal(true)
                                        setSelectedBraodcastContacts([])
                                        setCheckAllVal(false)
                                        setSelectedRds([])
                                        getRdList('my_rds')
                                    }}
                                >
                                    <HiChatBubbleLeftRight size={16} className="mr-50"/>
                                    <span>Mass Message</span>
                                </Button.Ripple>
                            </div>
                        </header>
                    </div>
                    <div
                        className={classnames("start-chat-area", {
                            "d-none": !!selectedContactDetail
                        })}>
                        {/* <div className='start-chat-area'> */}
                        <div className="start-chat-icon mb-1">
                            <MessageSquare/>
                        </div>
                        <h4 className="sidebar-toggle start-chat-text text-center">
                            <div>Select a RD First to Start Chat.</div>
                            <button className="d-sm-none btn btn-link font-medium-3 text-underline" onClick={handleStartConversation}>
                                Tap Here
                            </button>
                        </h4>
                    </div>
                </div>
                <div
                    className={classnames("active-chat", {
                        "d-none": selectedContactDetail === null
                    })}
                >
                    <div className="chat-navbar">
                        <header className="chat-header justify-content-between">
                            <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div className="sidebar-toggle d-block d-lg-none mr-1">
                                    <button onClick={handleSidebar} className='btn btn-link p-0'>
                                        <ChevronLeft size={21}/>
                                    </button>
                                </div>
                                {selectedContactDetail && (
                                    selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                                        <div className='d-flex align-items-center text-body ml-25 overflow-hidden'>
                                            <div
                                                className="d-flex align-items-center justify-content-center flex-shrink-0 mr-50"
                                                style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'rgba(86, 182, 255, 0.12)',
                                                    color: '#008be3',
                                                    border: '1.5px solid rgba(86, 182, 255, 0.35)',
                                                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                                                }}
                                                title="Mass Message Broadcast"
                                            >
                                                <Users size={18} />
                                            </div>
                                            <div className='d-flex flex-column justify-content-center overflow-hidden'>
                                                <h6 className='mb-0 font-weight-bold text-truncate' style={{ lineHeight: '1.2', fontSize: '13px' }}>
                                                    {selectedContactDetail?.name || 'Mass Message'}
                                                </h6>
                                                {getHeaderSubtitle()}
                                            </div>
                                        </div>
                                    ) : (
                                        <Link
                                            to={`/dashboard/brands/nutritions/${selectedContactDetail?.chat_user}`}
                                            className='d-flex align-items-center text-body ml-25 overflow-hidden'
                                            title='View RD profile'
                                        >
                                            <CustomAvatar
                                                name={selectedContactDetail?.name || selectedContactDetail?.rd_name}
                                                img={selectedContactDetail?.profile_image || selectedContactDetail?.profile_img}
                                                imgHeight='36'
                                                imgWidth='36'
                                                className='mr-50 flex-shrink-0'
                                            />
                                            <div className='d-flex flex-column justify-content-center overflow-hidden'>
                                                <h6 className='mb-0 font-weight-bold text-truncate' style={{ lineHeight: '1.2', fontSize: '13px' }}>
                                                    {selectedContactDetail?.name || selectedContactDetail?.rd_name}
                                                </h6>
                                                {getHeaderSubtitle()}
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>

                            {/* Header Actions — Right Side */}
                            {selectedContactDetail && !(selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass') && (
                                <div className='d-flex align-items-center ml-1' style={{ gap: '6px' }}>
                                    {/* Profile Button — desktop view */}
                                    <Link
                                        to={`/dashboard/brands/nutritions/${selectedContactDetail?.chat_user}`}
                                        className='btn btn-outline-secondary btn-icon btn-sm d-none d-md-inline-flex align-items-center justify-content-center chat-header-action-btn'
                                        title='View Profile'
                                        style={{ width: '34px', height: '34px', padding: 0, borderRadius: '8px' }}
                                    >
                                        <User size={16} />
                                    </Link>

                                    {/* Archive / Unarchive Button — desktop view */}
                                    {isThreadArchived ? (
                                        <Button
                                            outline
                                            color='secondary'
                                            size='sm'
                                            className='d-none d-md-inline-flex align-items-center chat-header-action-btn'
                                            style={{ height: '34px', borderRadius: '8px', padding: '0 10px', fontSize: '12px' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                sweetAlert.fire({
                                                    title: 'Unarchive this thread?',
                                                    text: 'It will be moved back to your Inbox.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Unarchive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(unarchiveConversation(selectedContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('inbox')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            <UnarchiveIcon size={14} className='mr-25' />
                                            <span>Unarchive</span>
                                        </Button>
                                    ) : (
                                        <Button
                                            outline
                                            color='secondary'
                                            size='sm'
                                            className='d-none d-md-inline-flex align-items-center chat-header-action-btn'
                                            style={{ height: '34px', borderRadius: '8px', padding: '0 10px', fontSize: '12px' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                sweetAlert.fire({
                                                    title: 'Archive this thread?',
                                                    text: 'It will be moved to your Archive tab.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Archive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(archiveConversation(selectedContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('archive')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            <ArchiveIcon size={14} className='mr-25' />
                                            <span>Archive</span>
                                        </Button>
                                    )}

                                    {/* 3-Dot Dropdown Menu */}
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            color='outline-secondary'
                                            size='sm'
                                            className='btn-icon chat-header-action-btn d-flex align-items-center justify-content-center'
                                            style={{ width: '34px', height: '34px', padding: 0, borderRadius: '8px' }}
                                        >
                                            <MoreVertical size={16} />
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            {/* Mobile-only responsive fallbacks */}
                                            <DropdownItem
                                                tag={Link}
                                                to={`/dashboard/brands/nutritions/${selectedContactDetail?.chat_user}`}
                                                className='d-flex d-md-none align-items-center'
                                            >
                                                <User size={14} className='mr-50' />
                                                <span>View Profile</span>
                                            </DropdownItem>
                                            {isThreadArchived ? (
                                                <DropdownItem
                                                    className='d-flex d-md-none align-items-center'
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        sweetAlert.fire({
                                                            title: 'Unarchive this thread?',
                                                            text: 'It will be moved back to your Inbox.',
                                                            icon: 'question',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Unarchive',
                                                            cancelButtonText: 'Cancel'
                                                        }).then(result => {
                                                            if (result.isConfirmed) {
                                                                dispatch(unarchiveConversation(selectedContactDetail?.chat_user))
                                                                if (onTabChange) {
                                                                    onTabChange('inbox')
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <UnarchiveIcon size={14} className='mr-50' />
                                                    <span>Unarchive Thread</span>
                                                </DropdownItem>
                                            ) : (
                                                <DropdownItem
                                                    className='d-flex d-md-none align-items-center'
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        sweetAlert.fire({
                                                            title: 'Archive this thread?',
                                                            text: 'It will be moved to your Archive tab.',
                                                            icon: 'question',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Archive',
                                                            cancelButtonText: 'Cancel'
                                                        }).then(result => {
                                                            if (result.isConfirmed) {
                                                                dispatch(archiveConversation(selectedContactDetail?.chat_user))
                                                                if (onTabChange) {
                                                                    onTabChange('archive')
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <ArchiveIcon size={14} className='mr-50' />
                                                    <span>Archive Thread</span>
                                                </DropdownItem>
                                            )}

                                            {/* Non-redundant action: Mark as Unread */}
                                            <DropdownItem
                                                className='d-flex align-items-center'
                                                onClick={() => {
                                                    dispatch(markConversationUnread(selectedContactDetail?.chat_user))
                                                    toast.success('Conversation marked as unread')
                                                }}
                                            >
                                                <Mail size={14} className='mr-50' />
                                                <span>Mark as Unread</span>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            )}
                        </header>
                    </div>
                    <ChatWrapper containerRef={ref => {
                        chatArea.current = ref
                    }}
                                 className="user-chats"
                                 options={{wheelPropagation: false}}
                    >
                        <div className="chats">
                            {selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                                renderMassMessageContent()
                            ) : (
                                <Fragment>
                                    {brandChatStoreSlice?.selectedUserBrandChatLoading ? (
                                        /* Skeleton loader — alternating left/right bubbles */
                                        <div className="chat-skeleton-loader px-1 py-1">
                                            {[true, false, true, false, true].map((isRight, i) => (
                                                <div key={i} className={`chat-skeleton-row ${isRight ? 'right' : 'left'}`}>
                                                    {!isRight && <div className="skeleton-avatar-sm" />}
                                                    <div className="skeleton-bubble" style={{width: `${45 + (i % 3) * 15}%`}} />
                                                    {isRight && <div className="skeleton-avatar-sm" />}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <Fragment>{renderChats()}</Fragment>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    </ChatWrapper>
                    {selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                        <div className="chat-app-form d-flex align-items-center justify-content-center p-2 bg-light border-top text-muted" style={{ minHeight: '60px' }}>
                            <Info size={16} className="mr-1 text-info" />
                            <span style={{ fontSize: '0.85rem' }}>Broadcast log view (read-only). Direct replies from RDs appear in your Inbox.</span>
                        </div>
                    ) : (
                    <div className="bg-white d-block chat-bottom-wrapper">
                        {fileUploadError &&
                            <div className="validation-err ml-1">{allowedFilesErrorMessages().IMAGE_AND_FILES} </div>}
                        {!brandChatStoreSlice?.selectedUserBrandChatLoading && showFollowUp && !isThreadArchived && (
                            <div className="chat-followup-banner">
                                <div className="chat-followup-banner-content">
                                    <Clock size={16} className='flex-shrink-0' style={{ color: '#7c2d12' }} />
                                    <span className='banner-text'>
                                        {daysSince >= 30
                                            ? `You replied in ${monthYear || formatMonthYear(lastMessageDate)} — still waiting on ${selectedContactDetail?.name || selectedContactDetail?.rd_name || 'nutritionist'}. Would you like to follow up?`
                                            : `You replied ${daysSince === 1 ? '1 day' : `${daysSince} days`} ago — still waiting on ${selectedContactDetail?.name || selectedContactDetail?.rd_name || 'nutritionist'}. Would you like to follow up?`}
                                    </span>
                                </div>
                                <div className="chat-followup-actions">
                                    <button
                                        type='button'
                                        className='btn btn-followup-banner'
                                        onClick={handleFollowUpClick}
                                    >
                                        Follow up
                                    </button>
                                    {!isThreadArchived && (
                                        <button
                                            type='button'
                                            className='btn btn-archive-banner'
                                            onClick={() => {
                                                sweetAlert.fire({
                                                    title: 'Archive this thread?',
                                                    text: 'It will be moved to your Archive tab.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Archive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(archiveConversation(selectedContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('archive')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            Archive
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                        <Form className="chat-app-form" onSubmit={(e) => handleSendMsg(e)}>
                            <Row>
                                <Col xs={12} lg={12}>
                                    <Editor
                                        editorState={msgEditorState}
                                        placeholder="Write a message..."
                                        onEditorStateChange={(e) => {
                                            setMsgEditorState(e)
                                            const contentState = e.getCurrentContent()
                                            if (contentState.hasText()) {
                                                setMsg(draftToHtml(convertToRaw(e.getCurrentContent())))
                                            } else {
                                                setMsg('')
                                            }
                                        }}
                                        toolbar={{
                                            options: ['inline', 'list', 'link'],
                                            inline: {
                                                options: ['bold', 'italic', 'underline']
                                            },
                                            list: {
                                                options: ['unordered', 'ordered']
                                            },
                                            link: {
                                                popupClassName: 'msg-editor-link-and-img',
                                                showOpenOptionOnHover: false
                                            }
                                        }}
                                        editorClassName='msg-editor'
                                        stripPastedStyles={true}
                                    />
                                </Col>
                                <Col xs={12} lg={12} className="d-flex justify-content-between align-items-center mt-1 pt-75 border-top">
                                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                        <Label
                                            className="btn-chat-icon-action mb-0 cursor-pointer"
                                            htmlFor="attach-doc"
                                            title="Attach file (PDF, Image, Doc)"
                                        >
                                            <Paperclip size={18} />
                                            <input type="file"
                                                id="attach-doc"
                                                accept=".pdf, .png, .jpg, .jpeg, .doc, .docx, .xlsx, .xls"
                                                onChange={changeHandler}
                                                hidden={true}
                                                disabled={sendMsgLoader}
                                            />
                                        </Label>

                                        {/* Template Icon Button & Animated Menu with Click-Outside Ref */}
                                        <div ref={templateBarRef} className="d-flex align-items-center" style={{ gap: '6px' }}>
                                            <button
                                                type="button"
                                                className={classnames("btn-chat-icon-action", { active: showTemplateBar })}
                                                title="Message Templates"
                                                onClick={() => setShowTemplateBar(!showTemplateBar)}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                                                    <line x1="8" y1="4" x2="8" y2="20"></line>
                                                    <line x1="12" y1="9" x2="18" y2="9"></line>
                                                    <line x1="12" y1="15" x2="18" y2="15"></line>
                                                </svg>
                                            </button>

                                            {/* Animated 2-Tag Option Menu with Cross Icon */}
                                            {showTemplateBar && (
                                                <div className="chat-template-action-bar">
                                                    <button
                                                        type="button"
                                                        className="btn-template-tag"
                                                        onClick={() => {
                                                            setIsOpenTempleteModal(false)
                                                            setOpenTemplatesModal(true)
                                                            setTemplateType('message')
                                                            setShowTemplateBar(false)
                                                        }}
                                                    >
                                                        <FileText size={13} />
                                                        <span>Templates</span>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn-template-save-tag"
                                                        onClick={() => {
                                                            setOpenTemplatesModal(false)
                                                            setIsOpenTempleteModal(true)
                                                            setTemplateType('message')
                                                            setShowTemplateBar(false)
                                                        }}
                                                        disabled={sendMsgLoader || msg.length === 0}
                                                    >
                                                        <Plus size={13} />
                                                        <span>Save Template</span>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn-template-close-tag"
                                                        onClick={() => setShowTemplateBar(false)}
                                                        title="Close"
                                                    >
                                                        <X size={13} />
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {questate.inQueFilePreview && (
                                            <div className="badge badge-light-primary d-flex align-items-center py-50 px-75 rounded-pill">
                                                {selectedFile?.type === "application/pdf" ? (
                                                    <FileText size="14" className="mr-50 text-primary" />
                                                ) : (
                                                    <Image size="14" className="mr-50 text-primary" />
                                                )}
                                                <span className="text-truncate mr-50 font-weight-bold" style={{ maxWidth: '140px', fontSize: '12px' }}>
                                                    {selectedFile?.name || 'Attached file'}
                                                </span>
                                                <X size={14}
                                                   className="cursor-pointer text-danger ml-25"
                                                   title="Remove attachment"
                                                   onClick={() => {
                                                       setQueState({ inQueFilePreview: '', inQueFile: '' })
                                                       setSelectedFile(null)
                                                   }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <Button
                                            color="primary"
                                            id="send-message"
                                            disabled={sendMsgLoader || msg.length === 0}
                                            size="sm"
                                            className="d-flex align-items-center"
                                        >
                                            {sendMsgLoader ? (
                                                <Spinner style={{ height: '14px', width: '14px' }} />
                                            ) : (
                                                <Fragment>
                                                    <Send size={15} className="mr-50" />
                                                    <span>Send</span>
                                                </Fragment>
                                            )}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    )}
                </div>
            </div>

            <MassMessageModal
                isOpen={isOpenBroadcastModal}
                toggle={() => {
                    setIsOpenBroadcastModal(!isOpenBroadcastModal)
                    setSelectedBraodcastContacts([])
                    setCheckAllVal(false)
                    setBroadCastRDsList([])
                    setMassMsgEditorState(null)
                    setBroadcastMessage('')
                    dispatch({ type: 'CLEAT_BROADCAST_LIST' })
                }}
                broadcastMessage={broadcastMessage}
                setBroadcastMessage={setBroadcastMessage}
                massMsgEditorState={massMsgEditorState}
                setMassMsgEditorState={setMassMsgEditorState}
                selectedBroadcastContacts={selectedBroadcastContacts}
                setSelectedBraodcastContacts={setSelectedBraodcastContacts}
                selectedRds={selectedRds}
                setSelectedRds={setSelectedRds}
                broadCastRDsList={broadCastRDsList}
                setBroadCastRDsList={setBroadCastRDsList}
                broadCastRDsListLoading={broadCastRDsListLoading}
                setBroadCastRDsListLoading={setBroadCastRDsListLoading}
                sendBroadcastMessage={sendBroadcastMessage}
                broadCastSendLoader={broadCastSendLoader}
                showPreviewModal={showPreviewModal}
                setShowPreviewModal={setShowPreviewModal}
                broadCastResStatus={broadCastResStatus}
                broadCastResMsg={broadCastResMsg}
                brandsDashboardStoreSlice={brandsDashboardStoreSlice}
                rdGroupListLoading={rdGroupListLoading}
                favFolderList={favFolderList}
                setFavFolderList={setFavFolderList}
                showFav={showFav}
                setShowFav={setShowFav}
                backToFav={backToFav}
                setBackToFav={setBackToFav}
                favFolderTitle={favFolderTitle}
                setFavFolderTitle={setFavFolderTitle}
                handleSelectedFolder={handleSelectedFolder}
                getRdList={getRdList}
                selectedRadio={selectedRadio}
                setSelectedRadio={setSelectedRadio}
                selectedGroupLabels={selectedGroupLabels}
                setSelectedGroupLabels={setSelectedGroupLabels}
                groupData={groupData}
                setGroupData={setGroupData}
                checkAllVal={checkAllVal}
                setCheckAllVal={setCheckAllVal}
                handleCheckAll={handleCheckAll}
                handleSelectBroadCastingContact={handleSelectBroadCastingContact}
                setIsOpenTempleteModal={setIsOpenTempleteModal}
                setOpenTemplatesModal={setOpenTemplatesModal}
                setTemplateType={setTemplateType}
                dispatch={dispatch}
                rdGroupList={rdGroupList}
                rdGroupListReset={rdGroupListReset}
            />

            {/* --- Template Modal --- */}
            <MsgTemplates showSaveModal={isOpenTempleteModal}
                          template={templateType === 'message' ? msg : broadcastMessage}
                          closeModal={() => {
                              setIsOpenTempleteModal(false)
                              setOpenTemplatesModal(false)
                              setTemplateType(null)
                          }}
                          templateType={templateType}
                          showTemplatesModal={openTemplatesModal}
                          applyTemplate={(data) => {
                              appendTemplate(data)
                          }}
            />
        </Fragment>
    )
}

ChatLog.propTypes = {
    handleUser: PropTypes.func.isRequired,
    handleUserSidebarRight: PropTypes.func.isRequired,
    handleSidebar: PropTypes.func.isRequired,
    store: PropTypes.object,
    userSidebarLeft: PropTypes.bool.isRequired,
    user: PropTypes.object,
    selectedUserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedUserBrandChat: PropTypes.object,
    selectedContactDetail: PropTypes.object,
    currentUser: PropTypes.object
}

export default memo(ChatLog)